import axios from 'axios';

const CUSTOM_FIELDS_SOURCES_PATH = 'users/custom-fields';

export default {
  namespaced: true,
  state: {
    data: [],
    dataTypes: [],
    hasError: false,
    errorMsg: '',
    hasSuccess: false,
    isLoading: false,
  },
  getters: {
    getCustomFieldsForCommunications(state) {
      const mappedCustomFields = state.data.map(customField => {
        // Regex used by V1 cron
        const customFieldLabel = customField.name
          .replace(/[\s_]/gi, '-')
          .replace(/[^\w-]/gi, '')
          .replace(/-{2,}/gi, '-');
        return {
          value: `{{customfield_${customField.id}_${customFieldLabel}}}`,
          text: customField.name,
        };
      });
      return mappedCustomFields;
    },
  },
  mutations: {
    setData(state, data) {
      state.data = data;
    },
    setDataTypes(state, data) {
      state.dataTypes = data;
    },
    setError(state, error) {
      state.hasError = true;
      state.errorMsg = error.error;
    },
    clearError(state) {
      state.hasError = false;
      state.errorMsg = '';
    },
    setSuccess(state, bool) {
      state.isLoading = false;
      state.hasError = false;
      state.errorMsg = '';
      state.hasSuccess = bool;
    },
    clearMessages(state) {
      state.isLoading = false;
      state.hasError = false;
      state.errorMsg = '';
      state.hasSuccess = false;
    },
    setIsLoading(state, bool) {
      state.isLoading = bool;
    },
  },
  actions: {
    async findCustomFields({ commit }) {
      try {
        commit('setIsLoading', true);
        const { data } = await axios.get(
          `${process.env.VUE_APP_ACCOUNTS_API}/${CUSTOM_FIELDS_SOURCES_PATH}?$limit=0&$sort[numRank]=1`,
        );
        commit('setData', data.data);
        commit('setSuccess', true);
      } catch (error) {
        commit('setError', error);
      }
    },
    async findSysDataTypes({ commit }) {
      try {
        commit('setIsLoading', true);
        const { data } = await axios.get(
          `${process.env.VUE_APP_ACCOUNTS_API}/${CUSTOM_FIELDS_SOURCES_PATH}/sys-data-types`,
        );
        commit('setDataTypes', data.data);
        commit('setSuccess', true);
      } catch (error) {
        commit('setError', error);
      }
    },
    async saveCustomField({ commit }, payload) {
      try {
        commit('setIsLoading', true);
        delete payload.id;
        await axios.post(
          `${process.env.VUE_APP_ACCOUNTS_API}/${CUSTOM_FIELDS_SOURCES_PATH}`,
          payload,
        );
        commit('setSuccess', true);
      } catch (error) {
        commit('setError', error);
      }
    },
    async updateCustomField({ commit }, payload) {
      try {
        commit('setIsLoading', true);
        await axios.patch(
          `${process.env.VUE_APP_ACCOUNTS_API}/${CUSTOM_FIELDS_SOURCES_PATH}/${payload.id}`,
          payload,
        );
        commit('setSuccess', true);
      } catch (error) {
        commit('setError', error);
      }
    },
    async updateRanks({ commit }, payload) {
      try {
        commit('setIsLoading', true);
        await axios.put(
          `${process.env.VUE_APP_ACCOUNTS_API}/${CUSTOM_FIELDS_SOURCES_PATH}/ranks`,
          payload,
        );
        commit('setSuccess', true);
      } catch (error) {
        commit('setError', error);
      }
    },
    async deleteCustomField({ commit }, id) {
      try {
        commit('setIsLoading', true);
        await axios.delete(
          `${process.env.VUE_APP_ACCOUNTS_API}/${CUSTOM_FIELDS_SOURCES_PATH}/${id}`,
        );
        commit('setSuccess', true);
      } catch (error) {
        commit('setError', error);
      }
    },
  },
};
